import { useTheme } from '@mui/material';
import { Box, ButtonGroup } from '@mui/material';
import { useIntl } from 'react-intl';

import { Button } from '@verantos-dev/shared-components';

import { useSupervisorReviewTabSection } from './useSupervisorReviewTabSection';
import { SUPERVISOR_REVIEW_TAB_OPTIONS } from '../../../constants';

export const SupervisorReviewTabSelection = () => {
  const theme = useTheme();
  const {
    reviewTabSelected,
    handleReviewTabChange,
    annotatorOneName,
    annotatorTwoName,
    conflictsCount,
    resolvedCount,
  } = useSupervisorReviewTabSection();

  const { formatMessage } = useIntl();

  const buildTabLabel = (option: string) => {
    let lineTwo = '';
    if (option === 'annotator1') {
      lineTwo = annotatorOneName ?? '';
    } else if (option === 'annotator2') {
      lineTwo = annotatorTwoName ?? '';
    } else if (option === 'conflicts') {
      lineTwo = `${conflictsCount?.toString()} pending`;
    } else if (option === 'resolved') {
      lineTwo = `${resolvedCount?.toString()} total`;
    }
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', overflow: 'hidden', width: '100%' }}>
        <span style={{ fontWeight: '500', fontSize: '13px' }}>
          {formatMessage({ id: `supervisorReview.tab.${option}` })}
        </span>
        <Box
          component="span"
          title={lineTwo}
          className="supervisor-review-tab-line-two"
          sx={{
            textAlign: 'left',
            color: theme.palette.grey[800],
            fontSize: '14px',
            fontWeight: '400',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            display: 'block',
            maxWidth: '100%',
          }}
        >
          {lineTwo}
        </Box>
      </Box>
    );
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: theme.spacing(2) }}>
      <ButtonGroup
        color="inherit"
        orientation="horizontal"
        variant="contained"
        sx={{ width: '100%', borderRadius: 0, p: 0 }}
      >
        {SUPERVISOR_REVIEW_TAB_OPTIONS.map((option: string, index: number) => (
          <Button
            key={option}
            id={option}
            displayLabel={buildTabLabel(option)}
            sx={{
              backgroundColor:
                reviewTabSelected === option ? theme.palette.white.main : theme.palette.grey[200],
              color:
                reviewTabSelected === option ? theme.palette.text.primary : theme.palette.grey[600],
              textTransform: 'none',
              height: 'auto',
              py: theme.spacing(2),
              flex: 1,
              outline: 'none',
              '&:focus, &:focus-visible': {
                outline: 'none',
              },
              '&.Mui-focusVisible, &:focus, &:active': {
                backgroundColor:
                  reviewTabSelected === option ? theme.palette.white.main : theme.palette.grey[200],
              },
              '&:hover': {
                color: theme.palette.white.main,
                '& .supervisor-review-tab-line-two': {
                  color: theme.palette.white.main,
                },
              },
            }}
            onClickHandler={() => handleReviewTabChange(option)}
          />
        ))}
      </ButtonGroup>
    </Box>
  );
};
